"use strict";var inherit = require("raptor-util/inherit");
var domData = require("../components/dom-data");
var keysByDOMNode = domData._G_;
var vElementByDOMNode = domData._H_;
var createFragmentNode = require("./morphdom/fragment")._h_;
var VNode = require("./VNode");

function VFragment(key, ownerComponent, preserve) {
  this.bT_(null /* childCount */, ownerComponent);
  this.bU_ = key;
  this.aa_ = preserve;
}

VFragment.prototype = {
  bV_: 12,
  bl_: function () {
    var fragment = createFragmentNode();
    keysByDOMNode.set(fragment, this.bU_);
    vElementByDOMNode.set(fragment, this);
    return fragment;
  }
};

inherit(VFragment, VNode);

module.exports = VFragment;